import styled from 'styled-components';
import {
  AssessmentTestStep,
  AssessmentTestStepAnswer,
} from '../../../api/admin';
import { MarkdownWrapper, StickyHeaderModal } from './common';
import { renderSectionAnswer } from './StepQuestionsResults/StepModalComponents';
import { H5 } from '../../elements/Text';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 0;
`;

const SectionTitle = styled(H5)`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0;
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default function SelfAssessmentStepModal({
  isOpen,
  onClose,
  step,
  answer,
}: {
  isOpen: boolean;
  onClose: () => void;
  step: AssessmentTestStep;
  answer: AssessmentTestStepAnswer | undefined;
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <StickyHeaderModal title={step.label} onClose={onClose}>
      <Content>
        {/* Introduction */}
        <div>
          <SectionTitle>Introduction</SectionTitle>
          <SectionContent>
            <MarkdownWrapper md={step.introduction ?? ''} />
          </SectionContent>
        </div>

        {/* Questions and Answers */}
        {step.sections.map((section, index) => {
          const sectionAnswer = answer?.sections.find(
            (a) => a.id === section.id
          );

          return (
            <div key={section.id}>
              <SectionTitle>Question {index + 1}</SectionTitle>
              <SectionContent>
                <MarkdownWrapper md={section.content ?? ''} />
                {renderSectionAnswer(sectionAnswer, section)}
              </SectionContent>
            </div>
          );
        })}
      </Content>
    </StickyHeaderModal>
  );
}
